import {useEffect, useRef} from 'react';
import {Typography} from '~library/atoms/Typography';
import {largishAndUp} from '~libSass/base/_exports.sass';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import './Step.sass';

export const Step = ({step, isVisible}) => {
  const videoRef = useRef();
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;

  useEffect(() => {
    const videoCurrentRef = videoRef.current;
    if (isVisible && videoCurrentRef) {
      videoCurrentRef.pause();
      videoCurrentRef.currentTime = 0;
      videoCurrentRef.play();
    }
  }, [isVisible]);

  return (
    <div className="create_flow__carousel__step">
      <Typography
        variant={isMobile ? 'header3' : 'header2'}
        data-qa-id="onboardingTitle"
        color="charcoal"
        classNames="create_flow__carousel__step__title"
      >
        {step.subtitle}
      </Typography>

      <div className="create_flow__carousel__step__content">
        <div className="create_flow__carousel__step__content__inner">
          <video
            autoPlay
            width="100%"
            height="100%"
            preload="auto"
            playsInline
            muted
            loop
            className="create_flow__carousel__step__content__inner__video"
            ref={videoRef}
          >
            <source src={`${step.video}.webm`} type="video/webm" />
            <source src={`${step.video}.mp4`} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div>
    </div>
  );
};
